export function tenantsHaveEmails(cotenants) {
  if (!cotenants || !Array.isArray(cotenants)) {
    return false;
  }
  return cotenants.every(cotenant => cotenant.email !== null);
}
